import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { ResponsiveContext, Box, Text, Button } from 'grommet';
import { Halt, Money, ChatOption, Search } from 'grommet-icons';

import rulesName from '../../../../constants/rules';
import urlRoutes from '../../../../config/url-routes';

const OnboardingComponent = (props) => {
  const {
    userLogged: {
      rules
    },
    history,
  } = props;

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          direction='row'
          justify='center'
          margin={{ horizontal: 'medium', top: '100px' }}
        >
          <Box
            pad='small'
            width='xlarge'
            gap='medium'
          >

            {/* Cabeçalho */}
            <Box
              direction='row'
              gap='xsmall'
              align='baseline'
            >
              <Text size='large' color='dark-5'>Bem-vindo ao módulo de</Text>
              <Text size='xlarge' color='dark-1'>campanhas.</Text>
            </Box>

            {/* Conteúdo */}
            <Box
              gap='medium'
              direction={ size === 'small' || size === 'medium' ? 'column' : 'row' }
              justify='between'
            >
              {/* Primeira coluna */}
              <Box
                width={
                  size === 'small' || size === 'medium' ? 'xlarge' : 'xlarge'
                }
              >
                <Box
                  margin={{
                    bottom: size === 'small' ? 'large' : 'medium'
                  }}
                >
                  <Text color='dark-2' size='small'>
                    Comunicação em massa com seus cadastros.
                    Crie diversas campanhas e deixe as pessoas informadas sobre suas ações.
                  </Text>
                </Box>

                <Box
                  direction='row'
                  gap={ size === 'small' ? 'large' : 'medium' }
                  margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                >
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <ChatOption size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Crie suas campanhas
                    </Text>

                    <Text size='small' color='dark-2'>
                      Crie em poucos passos. Escolha a forma de envio, os cadastros e o conteúdo.
                    </Text>
                  </Box>

                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Search size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Busca avançada
                    </Text>

                    <Text size='small' color='dark-2'>
                      Filtre as campanhas por tipo, status e muito mais.
                    </Text>
                  </Box>
                </Box>

                <Box
                  direction='row'
                  gap={ size === 'small' ? 'large' : 'medium' }
                  margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                >
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Halt size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Cancele
                    </Text>

                    <Text size='small' color='dark-2'>
                      Cadastrou a campanha, mas desistiu de fazer a comunicação? É fácil cancelar.
                    </Text>
                  </Box>

                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    align='baseline'
                    width='50vw'
                  >
                    <Money size='medium' color='brand' />

                    <Text size='small' color='dark-2' weight='bold'>
                      Custo
                    </Text>

                    <Text size='small' color='dark-2'>
                      Sem sustos, fique sabendo no momento do cadastro o valor da campanha.
                    </Text>
                  </Box>
                </Box>

              </Box>

              {/* Separador coluna */}
              <Box
                width={ size === 'large' || size === 'xlarge' ? 'xsmall' : 'xxsmall'}
              />

              {/* Segunda coluna */}
              <Box
                gap='small'
                width={ size === 'small' || size === 'medium' ? 'xlarge' : 'xlarge' }
              >
                <Box
                  gap='medium'
                  round='small'
                  border={{ color: 'light-4' }}
                  pad={{
                    vertical: size === 'small' ? 'large' : 'medium',
                    horizontal:  size === 'small' ? 'medium' : 'small',
                  }}
                >
                  <Text color='dark-2' size='small'>
                    Comunique sobre...
                  </Text>

                  <Box>
                    <Text color='dark-2' size='small'>- Ações sobre seu mandato ou campanha.</Text>
                    <Text color='dark-2' size='small'>- Reuniões gerais.</Text>
                    <Text color='dark-2' size='small'>- Datas comemorativas.</Text>
                    <Text color='dark-2' size='small'>- E muito mais.</Text>
                  </Box>

                  <Button
                    primary
                    label='Começar, Criar campanha'
                    color='neutral-1'
                    title={!rules.includes(rulesName.createCampaign) ? 'Você não tem permissão para criar campanhas.' : null }
                    disabled={!rules.includes(rulesName.createCampaign)}
                    onClick={() =>
                      history.push(urlRoutes.campaignCreateUrl)
                    }
                  />
                </Box>

                {/*<Text color='dark-2' size='small'>
                  Caso tenha alguma dúvida entre em contato por WhatsApp ou e-mail.
                </Text>

                <Box>
                  <Text color='dark-2' size='small'>Suporte por WhatsApp</Text>
                </Box>*/}

              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  );
};

const mapStateToProps = ({ authReducer: { authenticated } }) => ({
  userLogged: authenticated,
});

const mapDispatchToProps = null

export const Onboarding = withRouter(connect(mapStateToProps, mapDispatchToProps)(OnboardingComponent));
